module.exports = __webpack_public_path__ + "static/img/mcn_pic2.8aaf9917.png";